import Vue from 'vue'
import Vuex from 'vuex'
import headerState from "@/store/modules/headerState"
import projects from "@/store/modules/projects"
import steps from "@/store/modules/steps";
import calc from "@/store/modules/calc";
import services from "@/store/modules/services";
import contacts from "@/store/modules/contacts";
import blog from "@/store/modules/blog";
import quiz from "@/store/modules/quiz";
import call from "@/store/modules/call";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  getters: {
  },
  modules: {
    headerState,
    projects,
    steps,
    calc,
    services,
    contacts,
    blog,
    quiz,
    call
  }
})
